import { TabNoData } from "../components/common/NoData";
import TextNavBackground from "../components/common/TextNavBackground";
import PollListCard from "../components/elements/polls/PollListCard";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kNewPollListURL } from "../utils/constants/apiUrls";
import { ONE_DAY_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";

// SAFE FIX: Deconstruct polls with an array default fallback
const PollList = ({ polls = [] }) => {
  return (
    <>
      {customStaticSeoConfig("Polls")}

      <TextNavBackground title="Polls" />

      <TabNoData />

      {/* <section className="py-6 sm:py-1200 text-gray-100 max-w-7xl mx-auto lg:max-w-7xl">
        <div className="container p-6 mx-auto space-y-8">
          <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
            {polls.map((poll) => (
              <PollListCard key={poll.id} poll={poll} />
            ))}
          </div>
        </div>
      </section> */}
    </>
  );
};

export default PollList;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const polls = await apiWrapper.get(kNewPollListURL, token);

  return {
    props: {
      // SAFE FIX: Provide an array fallback if the API data cannot be read
      polls: polls?.data || [],
    },
    revalidate: ONE_DAY_REFRESH_INTERVAL_SECONDS,
  };
};
